// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-export/plugin.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/plugins/src/export/index.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo custodia-parental-app
//     node fleet/fleet.ts check --repo custodia-parental-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * `plugins/export` — one folder, one plugin, everything it owns.
 *
 * EXPORT DELIVERY as a kernel plugin — the only part of `export/` that is one.
 *
 * It registers a service and nothing else: no route, no nav entry, no job. The
 * kernel mounts whichever mount points exist, so a plugin with only `data` is
 * perfectly normal.
 */
import { type Plugin, serviceToken } from "@fleet/kernel";
import type { ExportDelivery } from "@fleet/export";

export const EXPORT_DELIVERY = serviceToken<ExportDelivery>("export.delivery");

export interface ExportPluginConfig {
  /** Always required: the fallback that works anywhere there is a DOM. */
  browser: ExportDelivery;
  /**
   * Used when the host reports the `fileSystem` capability (Tauri). Optional:
   * an app that only ships to the web simply does not pass it.
   */
  fileSystem?: ExportDelivery;
}

export const exportPlugin: Plugin<ExportPluginConfig> = {
  id: "export",
  provides: [EXPORT_DELIVERY],
  // No window, no way to hand a file to anybody. On an SSR render the plugin is
  // skipped and every call site sees `undefined`, which is the honest answer.
  capabilities: ["window"],

  data(ctx) {
    const delivery =
      ctx.caps.fileSystem && ctx.config.fileSystem ? ctx.config.fileSystem : ctx.config.browser;
    ctx.provide(EXPORT_DELIVERY, delivery);
    ctx.log("delivery_selected", { kind: delivery.kind });
  },
};

export { tauriDelivery } from "./tauri-delivery";
